import {combineReducers} from 'redux'
import types from 'actions/types'
import {createPivotTableReducer} from 'reducers/pivotTable'
import {get} from 'lodash'

export const scheduledDateTimeKey = (state = null, action) => {
  switch (action.type) {
    case types.DELIVERIES_DELIVERY_NOTES_UPDATE_FILTERS:
      return get(action, 'filters.scheduledDateTimeKey', state)
    default:
      return state
  }
}

export const scheduledDateTargetStart = (state = null, action) => {
  switch (action.type) {
    case types.DELIVERIES_DELIVERY_NOTES_UPDATE_FILTERS:
      return get(action, 'filters.scheduledDateTargetStart', state)
    default:
      return state
  }
}

export const scheduledDateTargetEnd = (state = null, action) => {
  switch (action.type) {
    case types.DELIVERIES_DELIVERY_NOTES_UPDATE_FILTERS:
      return get(action, 'filters.scheduledDateTargetEnd', state)
    default:
      return state
  }
}

export const deliveredDateTimeKey = (state = null, action) => {
  switch (action.type) {
    case types.DELIVERIES_DELIVERY_NOTES_UPDATE_FILTERS:
      return get(action, 'filters.deliveredDateTimeKey', state)
    default:
      return state
  }
}

export const deliveredDateTargetStart = (state = null, action) => {
  switch (action.type) {
    case types.DELIVERIES_DELIVERY_NOTES_UPDATE_FILTERS:
      return get(action, 'filters.deliveredDateTargetStart', state)
    default:
      return state
  }
}

export const deliveredDateTargetEnd = (state = null, action) => {
  switch (action.type) {
    case types.DELIVERIES_DELIVERY_NOTES_UPDATE_FILTERS:
      return get(action, 'filters.deliveredDateTargetEnd', state)
    default:
      return state
  }
}

export const status = (state = [], action) => {
  switch (action.type) {
    case types.DELIVERIES_DELIVERY_NOTES_UPDATE_FILTERS:
      return get(action, 'filters.status', state)
    default:
      return state
  }
}

export const jobStatus = (state = [], action) => {
  switch (action.type) {
    case types.DELIVERIES_DELIVERY_NOTES_UPDATE_FILTERS:
      return get(action, 'filters.jobStatus', state)
    default:
      return state
  }
}

export const printedEmailed = (state = [], action) => {
  switch (action.type) {
    case types.DELIVERIES_DELIVERY_NOTES_UPDATE_FILTERS:
      return get(action, 'filters.printedEmailed', state)
    default:
      return state
  }
}

export const deliveryMethod = (state = [], action) => {
  switch (action.type) {
    case types.DELIVERIES_DELIVERY_NOTES_UPDATE_FILTERS:
      return get(action, 'filters.method', state)
    default:
      return state
  }
}

export const returnReason = (state = [], action) => {
  switch (action.type) {
    case types.DELIVERIES_DELIVERY_NOTES_UPDATE_FILTERS:
      return get(action, 'filters.returnReason', state)
    default:
      return state
  }
}



export const deliveryNotesPivotTableKey = 'deliveriesContext.deliveryNotes.deliveryNotes'

export default combineReducers({
  scheduledDateTimeKey,
  scheduledDateTargetStart,
  scheduledDateTargetEnd,
  deliveredDateTimeKey,
  deliveredDateTargetStart,
  deliveredDateTargetEnd,
  status,
  jobStatus,
  printedEmailed,
  deliveryMethod,
  returnReason,
  deliveryNotes: createPivotTableReducer({key: deliveryNotesPivotTableKey, defaultSortColumn: 'createdDate', defaultSortDirection: 'desc'}),
})
